export const trackProductTileGallerySwipe =
  (options: {
    sponsored: boolean;
    sponsoredType?: string;
    sortingChannel: string;
    itemId: number;
    locationId: string;
    name?: string;
    creativeName?: string;
    promotionId?: string;
  }) =>
  () => {
    const {
      name,
      sponsored,
      itemId,
      locationId,
      sortingChannel,
      sponsoredType,
      creativeName,
      promotionId,
    } = options;
    const event = {
      event: 'feature_sponsored',
      sponsored: `${sortingChannel}|${sponsored}|${sponsoredType || ''}`,
      name: name ?? 'picture_swipe',
      action: 'click',
      location_id: locationId,
      label: itemId,
      creative_name: creativeName,
      promotion_id: promotionId,
    };

    return event;
  };
